/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SlowAlignmentOptions } from './SlowAlignmentOptions';
import {
    SlowAlignmentOptionsFromJSON,
    SlowAlignmentOptionsFromJSONTyped,
    SlowAlignmentOptionsToJSON,
} from './SlowAlignmentOptions';

/**
 * 
 * @export
 * @interface AlignmentOptions
 */
export interface AlignmentOptions {
    /**
     * Either 'fast' or 'slow'
     * @type {string}
     * @memberof AlignmentOptions
     */
    methodKey: AlignmentOptionsMethodKeyConstants;
    /**
     * 
     * @type {SlowAlignmentOptions}
     * @memberof AlignmentOptions
     */
    slowOptions?: SlowAlignmentOptions;
}


/**
 * @export
 */
export const AlignmentOptionsMethodKeyConstants = {
    fast: 'fast',
    slow: 'slow'
} as const;
export type AlignmentOptionsMethodKeyConstants = typeof AlignmentOptionsMethodKeyConstants[keyof typeof AlignmentOptionsMethodKeyConstants];


/**
 * Check if a given object implements the AlignmentOptions interface.
 */
export function instanceOfAlignmentOptions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "methodKey" in value;

    return isInstance;
}

export function AlignmentOptionsFromJSON(json: any): AlignmentOptions {
    return AlignmentOptionsFromJSONTyped(json, false);
}

export function AlignmentOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlignmentOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'methodKey': json['methodKey'],
        'slowOptions': !exists(json, 'slowOptions') ? undefined : SlowAlignmentOptionsFromJSON(json['slowOptions']),
    };
}

export function AlignmentOptionsToJSON(value?: AlignmentOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'methodKey': value.methodKey,
        'slowOptions': SlowAlignmentOptionsToJSON(value.slowOptions),
    };
}

